import { useTargetReminders, type UseTargetRemindersResult, type ReminderPayload } from "./useTargetReminders";

interface UseEntityRemindersOptions {
  entityId: string;
  payload: ReminderPayload;
  enabled?: boolean;
}

export type UseEntityRemindersResult = UseTargetRemindersResult;

export function useEntityReminders({
  entityId,
  payload,
  enabled = true,
}: UseEntityRemindersOptions): UseEntityRemindersResult {
  return useTargetReminders({
    target: { type: "entity", id: entityId },
    payload,
    enabled,
  });
}
